var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00985F",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "M5.671 10.83c4.824 4.823 6.237 3.669 6.869 3.218.102-.058 2.438-1.564.985-3.017-3.37-3.37-2.686 1.01-5.877-2.18s1.191-2.506-2.179-5.876c-1.453-1.453-2.96.883-3.016.985C2 4.59.847 6.005 5.67 10.83Z"
})));
export default SvgPhone;